// extracted by mini-css-extract-plugin
export default {"mainContainer":"advantegesSection_mainContainer__BHoQ4"};